/**
 * This object will map shopify store location id per environment with the handle key on Contentful.
 *
 * Shopify Location per instances:
 *  Dev-4: https://admin.shopify.com/store/us4-devbirds/settings/locations.json
 *  Staging: https://admin.shopify.com/store/allbirds-partners/settings/locations.json
 *  Prod: https://admin.shopify.com/store/weareallbirds/settings/locations.json
 *
 * Constentful Store location content:
 *  App: https://app.contentful.com/
 *    Dev: Search for Content Type = Store Location
 *    Master: Search for Content Type = Store Location
 *
 */
const STORE_LOCATION_SHOPIFY_CONTENTFUL_MAPPING = {
  'us4-devbirds.myshopify.com': {
    67852894391: {
      name: 'ATL - Ponce City Market',
      shopifyLocationId: 'gid://shopify/Location/67852894391',
      contentfulHandle: 'atlanta-ponce-city-market',
    },
    67852927159: {
      name: 'LAX - Abbot Kinney',
      shopifyLocationId: 'gid://shopify/Location/67852927159',
      contentfulHandle: 'los-angeles-abbot-kinney',
    },
    67852959927: {
      name: 'NYC - Columbus',
      shopifyLocationId: 'gid://shopify/Location/67852959927',
      contentfulHandle: 'new-york-city-columbus',
    },
    67852992695: {
      name: 'NYC - Soho',
      shopifyLocationId: 'gid://shopify/Location/67852992695',
      contentfulHandle: 'new-york-city-soho',
    },
  },
  'allbirds-partners.myshopify.com': {
    60921118831: {
      name: 'ATL - Ponce City Market',
      shopifyLocationId: 'gid://shopify/Location/60921118831',
      contentfulHandle: 'atlanta-ponce-city-market',
    },
    34653241455: {
      name: 'AUS - South Congress',
      shopifyLocationId: 'gid://shopify/Location/34653241455',
      contentfulHandle: 'austin-south-congress',
    },
    15612772463: {
      name: 'BOS - Back Bay',
      shopifyLocationId: 'gid://shopify/Location/15612772463',
      contentfulHandle: 'boston-back-bay',
    },
    15612805231: {
      name: 'CHI - Lincoln Park',
      shopifyLocationId: 'gid://shopify/Location/15612805231',
      contentfulHandle: 'chicago-lincoln-park',
    },
    60921151599: {
      name: 'CHI - Oakbrook',
      shopifyLocationId: 'gid://shopify/Location/60921151599',
      contentfulHandle: 'chicago-oakbrook-center',
    },
    34653306991: {
      name: 'LAX - Abbot Kinney',
      shopifyLocationId: 'gid://shopify/Location/34653306991',
      contentfulHandle: 'los-angeles-abbot-kinney',
    },
    60919545967: {
      name: 'NYC - Columbus',
      shopifyLocationId: 'gid://shopify/Location/60919545967',
      contentfulHandle: 'new-york-city-columbus',
    },
    15552610415: {
      name: 'NYC - Soho',
      shopifyLocationId: 'gid://shopify/Location/15552610415',
      contentfulHandle: 'new-york-city-soho',
    },
    35973070959: {
      name: 'Online Staging Inventory',
      shopifyLocationId: 'gid://shopify/Location/35973070959',
      contentfulHandle: null,
    },
    61016375407: {
      name: 'OUT - SF Premium Outlets',
      shopifyLocationId: 'gid://shopify/Location/61016375407',
      contentfulHandle: 'san-francisco-premium-outlets',
    },
    35920248943: {
      name: 'PHL - Walnut',
      shopifyLocationId: 'gid://shopify/Location/35920248943',
      contentfulHandle: 'philadelphia-walnut-street',
    },
    34657370223: {
      name: 'SAN - UTC La Jolla',
      shopifyLocationId: 'gid://shopify/Location/34657370223',
      contentfulHandle: 'san-diego-utc-la-jolla',
    },
    15612870767: {
      name: 'SEA - University Village',
      shopifyLocationId: 'gid://shopify/Location/15612870767',
      contentfulHandle: 'seattle-university-village',
    },
    15552577647: {
      name: 'SF - Headquarters',
      shopifyLocationId: 'gid://shopify/Location/15552577647',
      contentfulHandle: 'san-francisco-jackson-square',
    },
    34653339759: {
      name: 'SFO - Hayes Valley',
      shopifyLocationId: 'gid://shopify/Location/34653339759',
      contentfulHandle: 'san-francisco-hayes-valley',
    },
    34653372527: {
      name: 'WDC - Georgetown',
      shopifyLocationId: 'gid://shopify/Location/34653372527',
      contentfulHandle: 'washington-dc-georgetown',
    },
  },
  'weareallbirds.myshopify.com': {
    60963029072: {
      name: 'ATL - Avalon',
      shopifyLocationId: 'gid://shopify/Location/60963029072',
      contentfulHandle: 'atlanta-avalon',
    },
    60916236368: {
      name: 'ATL - Ponce City Market',
      shopifyLocationId: 'gid://shopify/Location/60916236368',
      contentfulHandle: 'atlanta-ponce-city-market',
    },
    34833596560: {
      name: 'AUS - South Congress',
      shopifyLocationId: 'gid://shopify/Location/34833596560',
      contentfulHandle: 'austin-south-congress',
    },
    60892905552: {
      name: 'BCO - Pearl Street',
      shopifyLocationId: 'gid://shopify/Location/60892905552',
      contentfulHandle: 'boulder-pearl-street',
    },
    60979511376: {
      name: 'BET - Bethesda Row',
      shopifyLocationId: 'gid://shopify/Location/60979511376',
      contentfulHandle: 'bethesda-bethesda-row-shopping-mall',
    },
    20076494917: {
      name: 'BOS - Back Bay',
      shopifyLocationId: 'gid://shopify/Location/20076494917',
      contentfulHandle: 'boston-back-bay',
    },
    60916334672: {
      name: 'BOS - Cambridge',
      shopifyLocationId: 'gid://shopify/Location/60916334672',
      contentfulHandle: 'cambridge-the-atrium',
    },
    60946972752: {
      name: 'BOS - Derby Street',
      shopifyLocationId: 'gid://shopify/Location/60946972752',
      contentfulHandle: 'hingham-derby-street-shops',
    },
    61119955024: {
      name: 'BOS - Prudential Center',
      shopifyLocationId: 'gid://shopify/Location/61119955024',
      contentfulHandle: 'boston-prudential-center',
    },
    60962963536: {
      name: 'CHI - Fulton Market',
      shopifyLocationId: 'gid://shopify/Location/60962963536',
      contentfulHandle: 'chicago-fulton-market',
    },
    20076462149: {
      name: 'CHI - Lincoln Park',
      shopifyLocationId: 'gid://shopify/Location/20076462149',
      contentfulHandle: 'chicago-lincoln-park',
    },
    60916269136: {
      name: 'CHI - Oakbrook',
      shopifyLocationId: 'gid://shopify/Location/60916269136',
      contentfulHandle: 'chicago-oakbrook-center',
    },
    60946907216: {
      name: 'CLT - South End',
      shopifyLocationId: 'gid://shopify/Location/60946907216',
      contentfulHandle: 'charlotte-south-end',
    },
    61564420176: {
      name: 'CMB - Easton Town Center',
      shopifyLocationId: 'gid://shopify/Location/61564420176',
      contentfulHandle: 'columbus-easton-town-center',
    },
    60941762640: {
      name: 'DEN - Cherry Creek',
      shopifyLocationId: 'gid://shopify/Location/60941762640',
      contentfulHandle: 'denver-cherry-creek-shopping-center',
    },
    61119922256: {
      name: 'DET - Somerset',
      shopifyLocationId: 'gid://shopify/Location/61119922256',
      contentfulHandle: 'detroit-somerset-collection',
    },
    61564387408: {
      name: 'GRN - Greenwich Avenue',
      shopifyLocationId: 'gid://shopify/Location/61564387408',
      contentfulHandle: 'greenwich-greenwich-avenue',
    },
    60979544144: {
      name: 'HOU - Rice Village',
      shopifyLocationId: 'gid://shopify/Location/60979544144',
      contentfulHandle: 'houston-rice-village',
    },
    33077985360: {
      name: 'LAX - Abbot Kinney',
      shopifyLocationId: 'gid://shopify/Location/33077985360',
      contentfulHandle: 'los-angeles-abbot-kinney',
    },
    60916301904: {
      name: 'LAX - Century City',
      shopifyLocationId: 'gid://shopify/Location/60916301904',
      contentfulHandle: 'los-angeles-century-city',
    },
    60892840016: {
      name: 'LAX - Pasadena',
      shopifyLocationId: 'gid://shopify/Location/60892840016',
      contentfulHandle: 'los-angeles-pasadena',
    },
    60963094608: {
      name: 'LAX - Studio City',
      shopifyLocationId: 'gid://shopify/Location/60963094608',
      contentfulHandle: 'los-angeles-studio-city',
    },
    60979576912: {
      name: 'LAX - The Point',
      shopifyLocationId: 'gid://shopify/Location/60979576912',
      contentfulHandle: 'los-angeles-the-point',
    },
    60892807248: {
      name: 'MSP - North Loop',
      shopifyLocationId: 'gid://shopify/Location/60892807248',
      contentfulHandle: 'minneapolis-north-loop',
    },
    60962996304: {
      name: 'NSH - Green Hills',
      shopifyLocationId: 'gid://shopify/Location/60962996304',
      contentfulHandle: 'nashville-green-hills',
    },
    60941729872: {
      name: 'NWJ Garden State Plaza',
      shopifyLocationId: 'gid://shopify/Location/60941729872',
      contentfulHandle: 'garden-state-plaza',
    },
    60916170832: {
      name: 'NYC - Columbus',
      shopifyLocationId: 'gid://shopify/Location/60916170832',
      contentfulHandle: 'new-york-city-columbus',
    },
    60947005520: {
      name: 'NYC - Flatiron',
      shopifyLocationId: 'gid://shopify/Location/60947005520',
      contentfulHandle: 'new-york-city-flatiron-district',
    },
    55508999: {
      name: 'NYC - Soho',
      shopifyLocationId: 'gid://shopify/Location/55508999',
      contentfulHandle: 'new-york-city-soho',
    },
    60963061840: {
      name: 'OCC - Fashion Island',
      shopifyLocationId: 'gid://shopify/Location/60963061840',
      contentfulHandle: 'newport-beach-fashion-island',
    },
    37342675024: {
      name: 'OUT - SF Premium Outlets',
      shopifyLocationId: 'gid://shopify/Location/37342675024',
      contentfulHandle: 'san-francisco-premium-outlets',
    },
    60979478608: {
      name: 'OUT - Wrentham Premium Outlet',
      shopifyLocationId: 'gid://shopify/Location/60979478608',
      contentfulHandle: 'wrentham-premium-outlets',
    },
    61124444240: {
      name: 'OUT Westgate Tanger',
      shopifyLocationId: 'gid://shopify/Location/61124444240',
      contentfulHandle: 'glendale-westgate-tanger-outlets',
    },
    60979642448: {
      name: 'PHL - King of Prussia',
      shopifyLocationId: 'gid://shopify/Location/60979642448',
      contentfulHandle: 'philadelphia-king-of-prussia',
    },
    34833694864: {
      name: 'PHL - Walnut',
      shopifyLocationId: 'gid://shopify/Location/34833694864',
      contentfulHandle: 'philadelphia-walnut-street',
    },
    60979609680: {
      name: 'PHX - Kierland Commons',
      shopifyLocationId: 'gid://shopify/Location/60979609680',
      contentfulHandle: 'phoenix-kierland-commons',
    },
    60946939984: {
      name: 'SAN - Forum Carlsbad',
      shopifyLocationId: 'gid://shopify/Location/60946939984',
      contentfulHandle: 'san-diego-forum-carlsbad',
    },
    34833662096: {
      name: 'SAN - UTC La Jolla',
      shopifyLocationId: 'gid://shopify/Location/34833662096',
      contentfulHandle: 'san-diego-utc-la-jolla',
    },
    20076527685: {
      name: 'SEA - University Village',
      shopifyLocationId: 'gid://shopify/Location/20076527685',
      contentfulHandle: 'seattle-university-village',
    },
    55541767: {
      name: 'SF - Headquarters',
      shopifyLocationId: 'gid://shopify/Location/55541767',
      contentfulHandle: 'san-francisco-jackson-square',
    },
    61564354640: {
      name: 'SFO - Broadway Plaza',
      shopifyLocationId: 'gid://shopify/Location/61564354640',
      contentfulHandle: 'walnut-creek-broadway-plaza',
    },
    33078018128: {
      name: 'SFO - Hayes Valley',
      shopifyLocationId: 'gid://shopify/Location/33078018128',
      contentfulHandle: 'san-francisco-hayes-valley',
    },
    60892872784: {
      name: 'SFO - Stanford Shopping Center',
      shopifyLocationId: 'gid://shopify/Location/60892872784',
      contentfulHandle: 'palo-alto-stanford',
    },
    60963160144: {
      name: 'SFO - Village at Corte Madera',
      shopifyLocationId: 'gid://shopify/Location/60963160144',
      contentfulHandle: 'san-francisco-village-at-corte-madera',
    },
    34833629328: {
      name: 'WDC - Georgetown',
      shopifyLocationId: 'gid://shopify/Location/34833629328',
      contentfulHandle: 'washington-dc-georgetown',
    },
  },
  'allbirdsuk.myshopify.com': {
    12637274230: {
      name: 'LON - Covent Garden',
      shopifyLocationId: 'gid://shopify/Location/12637274230',
      contentfulHandle: 'london-covent-garden',
    },
    63984599172: {
      name: 'LON - Kings Road',
      shopifyLocationId: 'gid://shopify/Location/63984599172',
      contentfulHandle: 'london-kings-road',
    },
    38548701316: {
      name: 'LON - Marylebone',
      shopifyLocationId: 'gid://shopify/Location/38548701316',
      contentfulHandle: 'london-marylebone',
    },
    65280245892: {
      name: 'LON - Selfridges',
      shopifyLocationId: 'gid://shopify/Location/65280245892',
      contentfulHandle: 'london-selfridges',
    },
  },
};

/**
 * List of shopify location ids exluded from the mapping, these are distribution centers and disabled locations
 *
 * https://admin.shopify.com/store/weareallbirds/settings/locations/60916367440 - PHX - Scottsdale Quarter
 * https://admin.shopify.com/store/weareallbirds/settings/locations/49671111    - DC - US - Geodis
 * https://admin.shopify.com/store/weareallbirds/settings/locations/37334941776 - DC - US Virtual - UPS
 * *
 * https://admin.shopify.com/store/weareallbirds/settings/locations/55541767    - SFO - Headquarters (closed)
 * https://admin.shopify.com/store/weareallbirds/settings/locations/34833694864 - PHL - Walnut (closed)
 * https://admin.shopify.com/store/weareallbirds/settings/locations/60946939984 - SAN - Forum Carlsbad (closed)
 * https://admin.shopify.com/store/weareallbirds/settings/locations/60946972752 - BOS - Derby Street (closed)
 * https://admin.shopify.com/store/weareallbirds/settings/locations/60947005520 - NYC - Flatiron (closed)
 * https://admin.shopify.com/store/weareallbirds/settings/locations/61119922256 - DET - Somerset - Detroit (closed)
 * https://admin.shopify.com/store/weareallbirds/settings/locations/61124444240 - OUT - Westgate Tanger (closed)
 * https://admin.shopify.com/store/weareallbirds/settings/locations/60963094608 - LAX - Studio City
 * https://admin.shopify.com/store/weareallbirds/settings/locations/20076494917 - BOS - BACK Bay
 * https://admin.shopify.com/store/weareallbirds/settings/locations/34833596560 - AUS - South Congress
 * https://admin.shopify.com/store/weareallbirds/settings/locations/60979544144 - HOU - Rice Village
 * https://admin.shopify.com/store/weareallbirds/settings/locations/61564387408 - GRN - Greenwich Avenue
 * https://admin.shopify.com/store/weareallbirds/settings/locations/33077985360 - LAX - Abbot Kinney
 * https://admin.shopify.com/store/allbirdsuk/settings/locations/65280245892    - LON - Selfridges (store in-store)
 * https://admin.shopify.com/store/weareallbirds/settings/locations/60941729872 - NJ - Garden State Plaza
 * https://admin.shopify.com/store/weareallbirds/settings/locations/60979511376 - BET - Bethesda Row
 * https://admin.shopify.com/store/weareallbirds/settings/locations/60946907216 - CLT - South End
 * https://admin.shopify.com/store/weareallbirds/settings/locations/60916170832 - NYC Columbus
 * https://admin.shopify.com/store/weareallbirds/settings/locations/61564420176 - CMB - Easton Town Center
 * https://admin.shopify.com/store/weareallbirds/settings/locations/60963029072 - ATL - Avalon
 * https://admin.shopify.com/store/weareallbirds/settings/locations/60979576912 - LAX - The Point
 * https://admin.shopify.com/store/weareallbirds/settings/locations/61119955024 - BOS - Prudential Center
 * https://admin.shopify.com/store/weareallbirds/settings/locations/60941762640 - DEN - Cherry Creek
 * https://admin.shopify.com/store/weareallbirds/settings/locations/60962996304 - NSH - Green Hills
 */

const STORE_LOCATION_SHOPIFY_CONTENTFUL_EXCLUDED_LIST = [
  60916367440, 49671111, 37334941776, 34833694864, 61119922256, 61124444240, 60946972752,
  60947005520, 60946939984, 55541767, 60963094608, 20076494917, 34833596560, 60979544144,
  61564387408, 33077985360, 65280245892, 60941729872, 60979511376, 60916170832, 61564420176,
  60963029072, 60946907216, 60979576912, 61119955024, 60962996304, 60941762640,
];

/**
 * Shopify location id of the Distribution Center per geo shopify instance
 */
const WAREHOUSE_LOCATION_IDS = {
  US: [49671111, 37334941776],
  UK: [11239719030],
  EU: [30837506123],
};

export {
  STORE_LOCATION_SHOPIFY_CONTENTFUL_MAPPING,
  STORE_LOCATION_SHOPIFY_CONTENTFUL_EXCLUDED_LIST,
  WAREHOUSE_LOCATION_IDS,
};
